import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Container,
  Divider,
  ListItemIcon,
} from "@mui/material";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import Avatar from "@mui/material/Avatar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { dashboardIcon, images } from "../../config/images";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import translations from "../../config/language";

const Header = ({
  isSidebarOpen,
  setIsSidebarOpen,
  selectedIndex,
  isLogoutOpen,
  setIsLogoutOpen,
  setSelectedIndex,
  setChangePassword,
  changePassword
}) => {
  const [anchorEl, setAnchorEl] = useState(null);


  const {
    firstName,
    lastName,
    email,
    mobileNo,
    token,
    profilePhoto,
    role
  } = useSelector((state) => state.userState);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();
  const open = Boolean(anchorEl);

  const language = process.env.REACT_APP_LANGUAGE

  return (
    <Box
      sx={{
        position: "fixed",
        width: "100%",
        top: 0,
        left: 0,
        background: "#fff",
        boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
        zIndex: (isLogoutOpen || changePassword) ? 0 : 1000, // If either is true, zIndex is 0
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "auto"
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
        <Typography variant="h5" style={{ width: "229px", marginLeft: "20px" }} className="logo-h5">
          <img src={images.logo} alt="" className="nicra-logo" onClick={() => { setSelectedIndex("Dashboard"); navigate("/dashboard") }} />
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            {isSidebarOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
          <Typography variant="h5" sx={{ color: "#3C4856" }} className="sidemenu-h5">
            <b>{selectedIndex}</b>
          </Typography>
        </Box>
      </Box>
      <Box sx={{ flexGrow: 0 }} className="headerToolbar-wrap">
        <div onClick={handleClick} className="profileToggle-menu exclude-me">
          <Avatar
            alt=""
            src={profilePhoto}
            className="profile-toggle-img"
          />
          <div className="user-name">
            <p className="profileName">
              {firstName} {lastName}
            </p>
            <p className="user-role">
              {role == "3" ? "Admin" : "Super Admin"}
            </p>
          </div>

          <KeyboardArrowDownIcon className="ToggleIcon" />
        </div>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgb(84, 108, 138))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: -27,
                right: 0,
                width: 0,
                height: 0,
                borderLeft: "25px solid transparent",
                borderRight: "25px solid transparent",
                borderBottom: "50px solid #fff",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          disableScrollLock={true}
        >
          <MenuItem
            className="menu-item"
            sx={{ px: 3, py: 2 }}
            onClick={() => navigate("/user-profile")}
          >
            {translations[language].profile}
          </MenuItem>
          <MenuItem
            className="menu-item"
            sx={{ px: 3, py: 2 }}
            // onClick={() => navigate("/forgot-password")}
            onClick={() => setChangePassword(true)}
          >
            {translations[language].changePassword}
          </MenuItem>
          <MenuItem
            className="menu-item"
            sx={{ px: 3, py: 2 }}
            onClick={() => setIsLogoutOpen(true)}
          >
            {translations[language].logout}
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};
export default Header;
